import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'

import Forbidden from '../pages/Forbidden'
import NotFound from '../pages/NotFound'

// mmstyle
import DcLogin from '../hakotan/pages/DcLogin'
import DcTop from '../hakotan/pages/DcTop'
import DcUserManager from '../hakotan/pages/DcUserManager'
// import SendMail from '../hakotan/pages/DcSendMail'
import SendMailComp from '../hakotan/pages/DcSendMailComplete'
// import RegisterCorp from '../hakotan/pages/DcRegistCorpInput'
// import RegistUserInput from '../hakotan/pages/DcRegistUserInput'
import RegisterCorp from '../hakotan/pages/DcRegistUserInput'
import RegistUserConfirm from '../hakotan/pages/DcRegistUserConfirm'
import RegistUserComplete from '../hakotan/pages/DcRegistUserComplete'
import UpdateCorpInput from '../hakotan/pages/DcUpdateCorpInput'
import UpdateUserInput from '../hakotan/pages/DcUpdateUserInput'
import UpdateAccountConfirm from '../hakotan/pages/DcUpdateAccountConfirm'
import UpdateAccountComplete from '../hakotan/pages/DcUpdateAccountComplete'
import UpdateAccountInput from '../hakotan/pages/DcUpdateAccountInput'
import UpdatePasswordInput from '../hakotan/pages/DcUpdatePasswordInput'
// import UpdateUserConfirm from '../hakotan/pages/DcUpdateUserConfirm'
import OrderInput from '../hakotan/pages/DcOrderInput'
import OrderConfirm from '../hakotan/pages/DcOrderConfirm'
import ConstructInput from '../hakotan/pages/DcConstructInput'
import OrderComplate from '../hakotan/pages/DcOrderComplete'
import SupportInput from '../hakotan/pages/DcSupportInput'
import SupportConfirm from '../hakotan/pages/DcSupportConfirm'
import SupportComplete from '../hakotan/pages/DcSupportComplete'
import UseRule from '../hakotan/pages/DcUseRule'
import Faq from '../hakotan/pages/DcFaq'
import What from '../hakotan/pages/DcWhatMmStyle'
import DcError from '../hakotan/pages/DcError'
import UnSupported from '../components/common/UnSupported'
import PasswordResetInput from '../hakotan/pages/DcPasswordResetInput'
import PasswordResetConfirm from '../hakotan/pages/DcPasswordResetConfirm'
import PasswordResetUpdate from '../hakotan/pages/DcPasswordResetUpdate'
import PasswordResetComplete from '../hakotan/pages/DcPasswordResetComplete'
import BuildingResearchBusiness from '../hakotan/pages/DcBuildingResearchBusiness'
import BuildingResearchInput from '../hakotan/pages/DcBuildingResearchInput'
import BuildingResearchConfirm from '../hakotan/pages/DcBuildingResearchConfirm'
import BuildingResearchComplete from '../hakotan/pages/DcBuildingResearchComplete'
import FirstPassword from '../hakotan/pages/DcFirstPassword'
import Cart from '../hakotan/pages/DcCart'
import DcOrderHistoryList from '../hakotan/pages/DcOrderHistoryList'
import DcMyPage from '../hakotan/pages/DcMyPage'
import DcUserAccount from '../hakotan/pages/DcUserAccount'
import DcOrderHistoryDetail from '../hakotan/pages/DcOrderHistoryDetail'
// import DcProfitSetting from '../hakotan/pages/DcProfitSetting'
import DcCategory from '../hakotan/pages/DcCategory'
import DcAbout from '../hakotan/pages/DcAbout'
import DcConstructModel from '../hakotan/pages/DcConstructModel'
import DcPaymentGuide from '../hakotan/pages/DcPaymentGuide'
import DcRouteConfirm from '../hakotan/pages/DcRouteConfirm'
import DcGuideOrder from '../hakotan/pages/DcGuideOrder'
import DcGuidePayment from '../hakotan/pages/DcGuidePayment'

import DcCorpInformation from '../hakotan/pages/DcCorpInformation'
import DcTokutei from '../hakotan/pages/DcTokutei'
import DcPrivacyPolicy from '../hakotan/pages/DcPrivacyPolicy'
import DcSignUp from '../hakotan/pages/DcSignUp'
import DcSignIn from '../hakotan/pages/DcSignIn'
import DcSpecialPrice from '../hakotan/pages/DcSpecialPrice'
import DcNews from '../hakotan/pages/DcNews'
import DcOrderSignIn from '../hakotan/pages/DcOrderSignIn'
import DcPaymentSelect from '../hakotan/pages/DcPaymentSelect'
import DcOrderGuest from '../hakotan/pages/DcOrderGuest'
import DcCustomize from '../hakotan/pages/DcCustomize'
import DcSeriesPage from '../hakotan/pages/DcSeriesPage'
import DcPaymentService from '../hakotan/pages/DcPaymentService'
import DcClientInput from '../hakotan/pages/DcClientInput'
import DcClientComplete from '../hakotan/pages/DcClientComplete'

import {API_URL, PTN_DC, PTN_KG, PTN_KG_SHEET} from '../constants/App'
import * as Api from '../utils/Api'
import * as AppUtil from '../utils/App'
import * as Check from '../utils/Check'
import {LICENSE_TYPE} from '../constants/Type'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    // 事前現場調査入力画面
    {
      path: '/research/business',
      name: 'BuildingResearchBusiness',
      component: BuildingResearchBusiness,
      meta: {
        title: '事前現場調査内容入力'
      }
    },
    // 事前現場調査入力画面
    {
      path: '/research/input',
      name: 'BuildingResearchInput',
      component: BuildingResearchInput,
      meta: {
        title: '事前現場調査内容入力'
      }
    },
    // 事前現場調査確認画面
    {
      path: '/research/confirm',
      name: 'BuildingResearchConfirm',
      component: BuildingResearchConfirm,
      meta: {
        title: '事前現場調査依頼確認'
      }
    },
    // 事前現場調査完了画面
    {
      path: '/research/complete',
      name: 'BuildingResearchComplete',
      component: BuildingResearchComplete,
      meta: {
        title: '事前現場調査依頼完了'
      }
    },
    // mmstyle初回ログイン画面
    {
      path: '/password',
      name: 'FirstPassword',
      component: FirstPassword
    },
    // デジタルカタログ
    {
      path: '/login',
      name: 'DcLogin',
      component: DcLogin,
      meta: {
        title: 'トップ'
      }
    },
    {
      path: '/top',
      name: 'DcTop',
      component: DcTop,
      meta: {
        title: 'HAKOTAN｜カスタムオーダー収納家具のオンラインストア',
        description: 'HAKOTANはあなたのお部屋にピッタリの収納家具をオンラインでカスタムオーダーできます。1ミリ単位でのサイズオーダーやカラーをカスタマイズすることができます。暮らしにジャストフィットするあなただけの収納家具をお届けします。'
      }
    },
    {
      path: '/',
      name: 'DcTop',
      component: DcTop,
      meta: {
        title: 'HAKOTAN｜カスタムオーダー収納家具のオンラインストア',
        description: 'HAKOTANはあなたのお部屋にピッタリの収納家具をオンラインでカスタムオーダーできます。1ミリ単位でのサイズオーダーやカラーをカスタマイズすることができます。暮らしにジャストフィットするあなただけの収納家具をお届けします。'
      }
    },
    // デジタルカタログ
    {
      path: '/user/manager',
      name: 'DcUserManager',
      component: DcUserManager,
      meta: {
        title: 'ユーザ管理',
        requiresAuth: true,
        requireMessenger: true
      }
    },
    // デジタルカタログ 仮メール送信完了
    {
      path: '/user/mail-comp',
      name: 'SendMailComp',
      component: SendMailComp,
      meta: {
        title: 'ユーザ仮登録メール送信完了'
      }
    },
    // デジタルカタログ ユーザ新規登録
    {
      path: '/user/register',
      name: 'RegisterCorp',
      component: RegisterCorp,
      meta: {
        title: 'ユーザ情報入力'
      }
    },
    // デジタルカタログ ユーザ新規登録
    {
      path: '/user/confirm',
      name: 'RegistUserConfirm',
      component: RegistUserConfirm,
      meta: {
        title: 'ユーザ登録確認'
      }
    },
    // デジタルカタログ ユーザ新規登録
    {
      path: '/user/complete',
      name: 'RegistUserComplete',
      component: RegistUserComplete,
      meta: {
        title: 'ユーザ登録完了'
      }
    },
    // デジタルカタログ ユーザ情報 更新
    {
      path: '/user/update-corp',
      name: 'UpdateCorpInput',
      component: UpdateCorpInput,
      meta: {
        title: '企業情報入力',
        requiresAuth: true
      }
    },
    // デジタルカタログ ユーザ情報 更新
    {
      path: '/user/update-user',
      name: 'UpdateUserInput',
      component: UpdateUserInput,
      meta: {
        title: 'ユーザ情報入力',
        requiresAuth: true
      }
    },
    // デジタルカタログ アカウント情報 更新入力
    {
      path: '/user/update-account-input',
      name: 'UpdateAccountInput',
      component: UpdateAccountInput,
      meta: {
        title: 'アカウント情報入力',
        requiresAuth: true
      }
    },
    // // デジタルカタログ アカウント情報 更新確認
    {
      path: '/user/update-account-confirm',
      name: 'UpdateAccountConfirm',
      component: UpdateAccountConfirm,
      meta: {
        title: 'アカウント更新確認',
        requiresAuth: true
      }
    },
    // デジタルカタログ アカウント情報 更新確認
    {
      path: '/user/reset/update-account',
      name: 'UpdateAccountComplete',
      component: UpdateAccountComplete,
      meta: {
        title: 'アカウント更新完了'
      }
    },
    {
      path: '/user/mypage',
      name: 'DcMyPage',
      component: DcMyPage,
      meta: {
        title: 'マイページ',
        requiresAuth: true
      }
    },
    {
      path: '/mypage/user-account',
      name: 'DcUserAccount',
      component: DcUserAccount,
      meta: {
        title: 'アカウント管理',
        requiresAuth: true
      }
    },
    // デジタルカタログ パスワード情報 更新
    {
      path: '/user/update-password',
      name: 'UpdatePasswordInput',
      component: UpdatePasswordInput,
      meta: {
        title: 'パスワード情報入力',
        requiresAuth: true
      }
    },
    // デジタルカタログ 利用規約
    {
      path: '/user/use-rule',
      name: 'UseRule',
      component: UseRule,
      meta: {
        title: 'ご利用規約｜カスタムオーダー収納家具のHAKOTAN',
        description: 'ご利用規約。カスタムオーダー収納家具のHAKOTAN。1ミリ単位でのサイズオーダーや、カラーをカスタマイズすることができます。',
        requireMessenger: true
      }
    },
    {
      path: '/order/input',
      name: 'OrderInput',
      component: OrderInput,
      meta: {
        title: 'お届け先入力｜カスタムオーダー収納家具のHAKOTAN',
        description: 'お届け先入力。カスタムオーダー収納家具のHAKOTAN。1ミリ単位でのサイズオーダーや、カラーをカスタマイズすることができます。'
      }
    },
    {
      path: '/order/confirm',
      name: 'OrderConfirm',
      component: OrderConfirm,
      meta: {
        title: 'ご注文内容確認｜カスタムオーダー収納家具のHAKOTAN',
        description: 'ご注文内容確認。カスタムオーダー収納家具のHAKOTAN。1ミリ単位でのサイズオーダーや、カラーをカスタマイズすることができます。',
        requiresAuth: true
      }
    },
    {
      path: '/order/complete',
      name: 'OrderComplate',
      component: OrderComplate,
      meta: {
        title: '注文完了｜カスタムオーダー収納家具のHAKOTAN',
        description: '注文完了。カスタムオーダー収納家具のHAKOTAN。1ミリ単位でのサイズオーダーや、カラーをカスタマイズすることができます。',
        requiresAuth: true
      }
    },
    {
      path: '/order/construct',
      name: 'ConstructInput',
      component: ConstructInput,
      meta: {
        title: '組立設置先情報入力｜カスタムオーダー収納家具のHAKOTAN',
        requiresAuth: true
      }
    },
    {
      path: '/support/input',
      name: 'SupportInput',
      component: SupportInput,
      meta: {
        title: 'お問い合わせ入力'
      }
    },
    {
      path: '/support/confirm',
      name: 'SupportConfirm',
      component: SupportConfirm,
      meta: {
        title: 'お問い合わせ確認'
      }
    },
    {
      path: '/support/complete',
      name: 'SupportComplete',
      component: SupportComplete,
      meta: {
        title: 'お問い合わせ完了'
      }
    },
    {
      path: '/faq',
      name: 'Faq',
      component: Faq,
      meta: {
        title: 'よくある質問',
        requireMessenger: true
      }
    },
    {
      path: '/what',
      name: 'What',
      component: What,
      meta: {
        title: 'mm/styleとは',
        requireMessenger: true
      }
    },
    {
      path: '/user/reset/input',
      name: 'PasswordResetInput',
      component: PasswordResetInput,
      meta: {
        title: 'パスワードリセット'
      }
    },
    {
      path: '/user/reset/confirm',
      name: 'PasswordResetConfirm',
      component: PasswordResetConfirm,
      meta: {
        title: 'パスワードリセット完了'
      }
    },
    {
      path: '/user/reset/update',
      name: 'PasswordResetUpdate',
      component: PasswordResetUpdate,
      meta: {
        title: 'パスワードリセット'
      }
    },
    {
      path: '/user/reset/complete',
      name: 'PasswordResetComplete',
      component: PasswordResetComplete,
      meta: {
        title: 'パスワードリセット完了'
      }
    },
    {
      path: '/cart',
      name: 'Cart',
      component: Cart,
      meta: {
        title: 'カート｜カスタムオーダー収納家具のHAKOTAN',
        description: 'カート。カスタムオーダー収納家具のHAKOTAN。1ミリ単位でのサイズオーダーや、カラーをカスタマイズすることができます。',
        requireMessenger: true
      }
    },
    // {
    //   path: '/order/history',
    //   name: 'OrderHistoryList',
    //   component: OrderHistoryList,
    //   meta: {
    //     title: '注文履歴',
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/order/history/detail',
    //   name: 'OrderHistoryDetail',
    //   component: OrderHistoryDetail,
    //   meta: {
    //     title: '注文履歴詳細',
    //     requiresAuth: true
    //   }
    // },
    {
      path: '/mypage/history-list',
      name: 'DcOrderHistoryList',
      component: DcOrderHistoryList,
      meta: {
        title: '注文履歴リスト',
        requiresAuth: true
      }
    },
    {
      path: '/mypage/history-detail',
      name: 'DcOrderHistoryDetail',
      component: DcOrderHistoryDetail,
      meta: {
        title: '注文履歴詳細',
        requiresAuth: true
      }
    },
    // {
    //   path: '/top/profit',
    //   name: 'DcProfitSetting',
    //   component: DcProfitSetting,
    //   meta: {
    //     title: '価格表示設定',
    //     requiresAuth: true
    //   }
    // },
    {
      path: '/top/customize',
      name: 'DcCustomize',
      component: DcCustomize,
      meta: {
        title: 'カスタマイズ｜カスタムオーダー収納家具のHAKOTAN',
        description: 'カスタマイズ。カスタムオーダー収納家具のHAKOTAN。1ミリ単位でのサイズオーダーやカラーをカスタマイズすることができます。'
      }
    },
    {
      path: '/top/category',
      name: 'DcCategory',
      component: DcCategory,
      meta: {
        title: '商品一覧｜カスタムオーダー収納家具のHAKOTAN',
        description: '商品一覧。カスタムオーダー収納家具のHAKOTAN。1ミリ単位でのサイズオーダーやカラーをカスタマイズすることができます。'
      }
    },
    {
      path: '/top/about',
      name: 'DcAbout',
      component: DcAbout,
      meta: {
        title: 'はじめてのお客様へ'
      }
    },
    {
      path: '/top/construct',
      name: 'DcConstructModel',
      component: DcConstructModel,
      meta: {
        title: '施工事例'
      }
    },
    {
      path: '/top/payment-guide',
      name: 'DcPaymentGuide',
      component: DcPaymentGuide,
      meta: {
        title: 'ご購入ガイド'
      }
    },
    {
      path: '/top/guide-route-confirm',
      name: 'DcRouteConfirm',
      component: DcRouteConfirm,
      meta: {
        title: '搬入経路のご確認'
      }
    },
    {
      path: '/top/guide-order-trance',
      name: 'DcGuideOrder',
      component: DcGuideOrder,
      meta: {
        title: '送料・納期・配送'
      }
    },
    {
      path: '/top/guide-payment',
      name: 'DcGuidePayment',
      component: DcGuidePayment,
      meta: {
        title: 'お支払い方法'
      }
    },
    {
      path: '/top/corp-info',
      name: 'DcCorpInformation',
      component: DcCorpInformation,
      meta: {
        title: '会社案内'
      }
    },
    {
      path: '/top/tokutei',
      name: 'DcTokutei',
      component: DcTokutei,
      meta: {
        title: '特定商取引法に基づく表示｜カスタムオーダー収納家具のHAKOTAN',
        description: '特定商取引法に基づく表示。カスタムオーダー収納家具のHAKOTAN。1ミリ単位でのサイズオーダーや、カラーをカスタマイズすることができます。'
      }
    },
    {
      path: '/top/privacy-policy',
      name: 'DcPrivacyPolicy',
      component: DcPrivacyPolicy,
      meta: {
        title: 'プライバシーポリシー｜カスタムオーダー収納家具のHAKOTAN',
        description: 'プライバシーポリシー。カスタムオーダー収納家具のHAKOTAN。1ミリ単位でのサイズオーダーや、カラーをカスタマイズすることができます。'
      }
    },
    {
      path: '/top/sign-up',
      name: 'DcSignUp',
      component: DcSignUp,
      meta: {
        title: '新規会員登録'
      }
    },
    {
      path: '/top/sign-in',
      name: 'DcSignIn',
      component: DcSignIn,
      meta: {
        title: 'ログイン'
      }
    },
    {
      path: '/top/specialprice',
      name: 'DcSpecialPrice',
      component: DcSpecialPrice,
      meta: {
        title: '特別仕切り価格'
      }
    },
    {
      path: '/top/news',
      name: 'DcNews',
      component: DcNews,
      meta: {
        title: 'ニュース'
      }
    },
    {
      path: '/order/sign-in/:type',
      name: 'DcOrderSignIn',
      component: DcOrderSignIn,
      meta: {
        title: '購入前ログイン'
      }
    },
    {
      path: '/order/payment-select',
      name: 'DcPaymentSelect',
      component: DcPaymentSelect,
      meta: {
        title: '決済方法選択｜カスタムオーダー収納家具のHAKOTAN',
        description: '決済方法選択。カスタムオーダー収納家具のHAKOTAN。1ミリ単位でのサイズオーダーや、カラーをカスタマイズすることができます。'
      }
    },
    {
      path: '/order/guest',
      name: 'DcOrderGuest',
      component: DcOrderGuest,
      meta: {
        title: '発注者情報入力'
      }
    },
    {
      path: '/top/series',
      name: 'DcSeriesPage',
      component: DcSeriesPage,
      meta: {
        title: 'シリーズページ'
      }
    },
    {
      path: '/top/payment-service',
      name: 'DcPaymentService',
      component: DcPaymentService,
      meta: {
        title: '事業者様向け「後払い」サービスのご案内'
      }
    },
    {
      path: '/top/client-input',
      name: 'DcClientInput',
      component: DcClientInput,
      meta: {
        title: '顧客登録申し込み'
      }
    },
    {
      path: '/top/client-complete',
      name: 'DcClientComplete',
      component: DcClientComplete,
      meta: {
        title: '顧客登録申し込み完了'
      }
    },
    // 共通
    {
      path: '/error',
      name: 'DcError',
      component: DcError,
      meta: {}
    },
    {
      path: '/forbidden',
      name: 'Forbidden',
      component: Forbidden,
      meta: {}
    },
    {
      path: '/unsupported',
      name: 'UnSupported',
      component: UnSupported,
      meta: {}
    },
    {
      path: '/unsupported',
      name: 'UnSupported',
      component: UnSupported,
      meta: {}
    },
    // 必ず最後に定義
    {
      path: '*',
      name: 'NotFound',
      component: NotFound,
      meta: {
        title: 'ご指定のページが見つかりません。'
      }
    }
  ],
  scrollBehavior (to, from, savePosiotn) {
    return {x: 0, y: 0}
  }
})

// axiosのキャッシュ設定
axios.interceptors.request.use(function (config) {
  if (typeof config.params === 'undefined') {
    config.params = {}
  }
  if (typeof config.params === 'object') {
    if (typeof URLSearchParams === 'function' && config.params instanceof URLSearchParams) {
      config.params.append('_', Date.now())
    } else {
      config.params._ = Date.now()
    }
  }

  return config
})

/** タイトル設定 */
const setTitle = function (to) {
  let component = to.matched.find(e => e.meta.title)
  let url = location.href
  if (PTN_KG.test(url)) {
    document.title = component ? component.meta.title : ''
  } else if (PTN_DC.test(url)) {
    document.title = component ? component.meta.title : ''
    if (component.meta.description) {
      document.querySelector("meta[name='description']").setAttribute('content', component.meta.description)
    }
  } else {
    document.title = component ? component.meta.title : ''
  }
}

/** Intercomのメッセンジャーの表示 */
const dispMessenger = function (to) {
  window.Intercom('shutdown')
  if (to.matched.some(e => e.meta.requireMessenger)) {
    window.Intercom('boot', {
      app_id: 'vpld6oei',
      vertical_padding: 1,
      horizontal_padding: 23
    })
  }
}

/** ズームイン・ズームアウトの可否を設定 */
const setUserScaleNo = function () {
  let url = location.href
  let userNoScale = 'user-scalable=no'
  let viewport = document.querySelector('meta[name="viewport"]')
  let viewportContent = viewport.getAttribute('content')
  if (PTN_KG.test(url) && !PTN_KG_SHEET.test(url)) {
    // ズームイン・ズームアウトが不可に設定されていなかったら不可に設定する
    if (!viewportContent.match(userNoScale)) {
      viewport.setAttribute('content', viewportContent + ', ' + userNoScale)
    }
  } else {
    // ズームイン・ズームアウトが不可に設定されていたら可能に設定する
    if (viewportContent.match(userNoScale)) {
      let replaceViewportContent = viewportContent.replace(userNoScale, '').replace(/, $/, '')
      viewport.setAttribute('content', replaceViewportContent)
    }
  }
}

// 画面初期表示時にサーバーアクセスがないものについては、vue-routerの機能を利用して画面描画開始前に認証処理を行う。
router.beforeEach((to, from, next) => {
  // オーダースケッチ
  if (process.env.SKETCH_ORDER === 0) {
    if (to.path.indexOf('sketch') >= 0) {
      next('/error')
      setTitle(to)
      next()
      dispMessenger(to)
      return
    }
  }

  if (to.path.indexOf('unsupported') === -1) {
    let url = location.href
    if (PTN_DC.test(url)) {
      if (!Check.brawserCheck()) {
        if (from.path.indexOf('unsupported') >= 0) {
          next(false)
        } else {
          next('/unsupported')
          setTitle(to)
          next()
          dispMessenger(to)
        }
        return
      }
    }
  }

  // 画面初期表示時、認証チェック
  if (to.matched.some(e => e.meta.requiresAuth)) {
    axios.get(API_URL.INIT, {
      params: {
        pageUrl: to.path
      }
    }).then(response => {
      // お試しユーザーに許容していない画面はプランニング画面に遷移させる
      if (to.matched.some(e => e.meta.notPermitTrial) && AppUtil.getUserInfo().licenseType === LICENSE_TYPE.TRIAL) {
        router.push('/planning')
      } else {
        setTitle(to)
        next()
        dispMessenger(to)
        setUserScaleNo()
      }
    }).catch(error => {
      Api.handleError(error)
    })
    return
  }
  setTitle(to)
  next()
  dispMessenger(to)
  setUserScaleNo()
})

export default router



// WEBPACK FOOTER //
// ./src/main/js/router/index.js